export default __webpack_public_path__ + "static/media/Group1670.7b3c0d30.svg";